import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import './style.css';

class AddDemoCategories extends Component {
  constructor(props){
    super(props)

    this.state={
      file: '',
      order_no :"",
      categoryName:"",
     // catID:"",
      validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.saveData = this.saveData.bind(this);
    this._handleImageChange = this._handleImageChange.bind(this);
  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsCategoriesAddSuccess && nextProps.demoGraphicsCategoriesSuccessmessage){
      alert(nextProps.demoGraphicsCategoriesSuccessmessage);
      this.props.emptyDemographicsCategories();
      this.props.categoryList();
    }else if(nextProps.demoGraphicsCategoriesFailmessage){
      alert(nextProps.demoGraphicsCategoriesFailmessage);
      
      this.props.emptyDemographicsCategories();
    }
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
		let valid = true;
    let error = {};

		if (this.state.categoryName === "") {
      error.categoryName = "Can't leave empty";
			valid = false;
    }
    // if (this.state.catID === "") {
    //   error.catID = "Please enter cat_id";
    //   valid = false;
    // }else if (!this.state.catID.match(/^\d*$/)){
    //   error.catID = "Please only enter numeric characters in category_id";
    //   valid = false;
    // }
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }

    if( !this.state.file){
      error.file = "Please choose image";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){
      if (this.handleValidation()) {

        const catData = new FormData();
        catData.append('sampleFile', this.state.file);
        catData.append('categoryName', this.state.categoryName);
        catData.append('order_no', this.state.order_no);
     
        // catData.categoryName = this.state.categoryName;
        // catData.order_no = this.state.order_no;     
        this.props.createDemoCategory(catData);  
      
    }
  }

  categoryList(){
    this.props.categoryList();
  }

  _handleImageChange(e) {
    let reader = new FileReader();
    let file1 = e.target.files[0];

    this.setState({
      file: file1,
      value: e.target.value,
    });
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1> Add New Demographic's category</h1></div>
            <div className = "setbackbutton">
            <br/><button className = "editstudybackbtn"   onClick={this.categoryList.bind(this)}>Back</button><br/>
            <div className = "studypage">
            <label id = "lbl1">Category Name</label>
            <input type="text" className = "textFields" placeholder = "Category Name" name="categoryName" value={this.state.categoryName} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.categoryName}</div><br/>

            {/* <label id = "lbl1">Category ID</label>
            <input type="text" className = "textFields" placeholder = "Category ID" name="catID" value={this.state.catID} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.catID}</div><br/> */}

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/>
            <div id="backgroundimagechoose">
            <label >Background Image :</label>
            <input type="file" id="choosefile" onChange={this._handleImageChange} value={this.state.value}/>
            </div><br/>
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.file}</div><br/>
            <br/> 
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >Create</button></div><br/>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddDemoCategories;


// WEBPACK FOOTER //
// ./src/components/demographics/addDemoCategory.js